/**
 * Hasta dos iniciales de un nombre, para fichas y avatares.
 *
 * Se salta el tratamiento («Dr.», «Dra.»): las iniciales de «Dr. Mauro
 * Jiménez» son «MJ», no «DM». Solo cuentan las palabras con letras.
 */
export function iniciales(nombre: string): string {
  const palabras = nombre
    .trim()
    .replace(/^(dr|dra|lic|mtro|mtra)\.?\s+/i, '')
    .split(/\s+/)
    .filter((palabra) => /\p{L}/u.test(palabra));
  if (palabras.length === 0) return '?';
  return palabras
    .slice(0, 2)
    .map((palabra) => (palabra.match(/\p{L}/u)?.[0] ?? '').toUpperCase())
    .join('');
}
